// src/Conversion/SqlFormat.js
import { format, supportedDialects } from "sql-formatter";

export const formatSql = (input, language = "sql", tabSize = 2) => {
    try {
        if (!supportedDialects.includes(language)) {
            return `Unsupported SQL dialect: ${language}`;
        }

        return format(input, {
            language,
            tabWidth: tabSize,
            keywordCase: 'upper',
        });
    } catch (error) {
        return "Invalid SQL query";
    }
};

export const getSupportedDialects = () => supportedDialects;
